import { isLowCodePopupPageAction } from "./lowCodePopupPage.js";

export function hasMeaningfulLowCodeInteraction(config) {
  if (!config || typeof config !== "object") return false;

  if (isLowCodePopupPageAction(config)) {
    return !!(config.popupPageConfig || config.value);
  }

  if (!config.responseType) return false;
  if (["link", "jumpLink"].includes(config.responseType)) {
    return !!config.link;
  }
  if (config.responseType === "popup") {
    return !!(config.article || config.popupTitle || config.popupClass);
  }
  if (config.responseType === "popoverPage") {
    return !!(
      config.popoverPageId ||
      config.popoverPageTitle ||
      config.popoverPageData
    );
  }

  return false;
}
